import { render } from "./FilesCreate.vue?vue&type=template&id=207a30d2&scoped=true"
import script from "./FilesCreate.vue?vue&type=script&lang=js"
export * from "./FilesCreate.vue?vue&type=script&lang=js"

import "./FilesCreate.vue?vue&type=style&index=0&id=207a30d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207a30d2"]])

export default __exports__